export default __webpack_public_path__ + "static/nav-logo-5df3cd98cc9a02e6c8541a34fa74f098.png";